// extracted by mini-css-extract-plugin
export default {"DefaultLayout":"DefaultLayout_DefaultLayout__-w87j","contents":"DefaultLayout_contents__pD+Fq"};